module.exports = __webpack_public_path__ + "img/allchina.2a1e3a45.png";